import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import InstagramFeed from './InstagramFeed';
import styles from './Layout.module.css'; // Import CSS module

const Layout = () => {
  return (
    <div>
      <Header />
      <InstagramFeed />
      <div className={styles.container}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
